export default __webpack_public_path__ + "static/media/AutokritiAboutUs.db8c31fd.jpeg";